import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Raffle from './pages/Raffle';
import AdminDashboard from './pages/AdminDashboard';
import LoadingScreen from './components/LoadingScreen';
import { RaffleProvider } from './context/RaffleContext';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState('');
  const [isMintTime, setIsMintTime] = useState(false);

  const handleLoadingComplete = () => {
    setLoading(false);
  };

  useEffect(() => {
    const calculateTimeLeft = () => {
      const mintDate = new Date('2025-12-16T18:00:00Z');
      const now = new Date();
      const difference = mintDate - now;

      if (difference <= 0) {
        setIsMintTime(true);
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      let timeString = '';
      if (days > 0) {
        timeString = `${days}d ${hours}h ${minutes}m`;
      } else if (hours > 0) {
        timeString = `${hours}h ${minutes}m ${seconds}s`;
      } else if (minutes > 0) {
        timeString = `${minutes}m ${seconds}s`;
      } else {
        timeString = `${seconds}s`;
      }

      setTimeLeft(timeString);
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Router>
      <RaffleProvider>
        <div className="App">
          {loading ? (
            <LoadingScreen onLoadingComplete={handleLoadingComplete} />
          ) : (
            <>
              <a
                href="https://sentx.io/nft-marketplace/angry-alien-alliance"
                target="_blank"
                rel="noopener noreferrer"
                className="sticky-note"
              >
                <div className="sticky-note-content">
                  <span className="sticky-note-emoji">
                    {isMintTime ? '🚀' : '📅'}
                  </span>
                  <span className="sticky-note-text">
                    {isMintTime ? 'Trade Now on SentX' : `Starts in ${timeLeft}`}
                  </span>
                </div>
              </a>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/raffle" element={<Raffle />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </>
          )}
        </div>
      </RaffleProvider>
    </Router>
  );
}

export default App;
